import { Navigate, useLocation } from "react-router-dom";

// Brick series pages used to live under /:organizationId/collections/; keep old links working.
const LegacySeriesRedirect: React.FC = () => {
  const { pathname, search } = useLocation();
  return <Navigate to={pathname.replace("/collections/", "/series/") + search} replace />;
};

export default LegacySeriesRedirect;
